import styled from 'styled-components';
import { useCallback, useMemo, useState } from 'react';
import { IconButton } from '@mui/material';
import { SearchIcon } from '@heroicons/react/outline';
import { SearchTextInput } from '@styles/StyledTextField';

export const SearchInputWrapper = styled.div`
  width: 100%;
  position: relative;
  max-width: 550px;

  button {
    right: 5px;
    top: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
  }

  .deleteIcon {
    right: 35px;
  }
`;

interface ISearchInputProps {
  isWithDeleteIcon?: boolean;
  placeholder?: string;
  onSearch(value: string): void;
}

export const SearchInput = ({ placeholder, onSearch }: ISearchInputProps) => {
  const [searchText, setSearchText] = useState<string>('');

  const disableSearch = useMemo(() => !(searchText || '').trim().length, [searchText]);

  const onKeyHandler = useCallback(() => {
    onSearch(searchText);
  }, [searchText, onSearch]);

  return (
    <SearchInputWrapper>
      <SearchTextInput
        fullWidth
        value={searchText}
        id="outlined-basic"
        placeholder={placeholder || 'Search'}
        variant="outlined"
        onKeyDown={(event) => event.key === 'Enter' && !disableSearch && onKeyHandler()}
        onChange={({ target: { value } }) => setSearchText(value)}
      />

      <IconButton
        aria-label="search"
        disabled={disableSearch}
        sx={{ p: '10px' }}
        onClick={() => onSearch(searchText)}
      >
        <SearchIcon
          width={20}
          color={'#5C5C5C'}
        />
      </IconButton>
    </SearchInputWrapper>
  );
};
